import {
  ExternalInstallationResponse,
  ExternalConnectionError
} from '../../../interfaces/externalConnection.interface';
import { externalConnectionConfig } from '../../config/externalConnectionConfig';

export async function callInstallationCallback(
  params: Record<string, string>,
  signal?: AbortSignal,
  rawQueryString?: string
): Promise<ExternalInstallationResponse> {
  const controller = new AbortController()
  const timeout = setTimeout(() => controller.abort(), 10000)

  try {
    // Build URL with all query params appended
    const baseUrl = externalConnectionConfig.installationCallbackUrl
    const queryString = rawQueryString
      ? rawQueryString.startsWith('?')
        ? rawQueryString.slice(1)        // strip leading ? if present
        : rawQueryString
      : new URLSearchParams(params).toString()  // fallback when rawQueryString is not provided
    const fullUrl = `${baseUrl}?${queryString}`

    console.log('[Service] rawQueryString =', rawQueryString)
    console.log('[Service] params =', params)
    console.log('[Service] fullUrl =', fullUrl)

    const response = await fetch(fullUrl, {
      method: 'GET',
      signal: signal ?? controller.signal,
    })

    clearTimeout(timeout)

    console.log('[Service] response.status =', response.status)

    if (!response.ok) {
      throw {
        code: 'REQUEST_FAILED',
        message: `Request failed with status ${response.status}`,
        status: response.status,
      } as ExternalConnectionError
    }

    const json = await response.json()
    console.log('[Service] response json =', json)
    return json as ExternalInstallationResponse

  } catch (err: unknown) {
    clearTimeout(timeout)
    const isAbort = err instanceof DOMException && err.name === 'AbortError'
    
    console.log('[Service] FAILED. isAbort =', isAbort, 'err =', err)
    throw {
      code: isAbort ? 'REQUEST_TIMEOUT' : 'REQUEST_FAILED',
      message: isAbort ? 'Request timed out after 10 seconds' : 'Installation callback failed',
      status: undefined,
    } as ExternalConnectionError
  }
}
